"use client";
import React from "react";
import { usePathname } from "next/navigation";
import { Merchant } from "@/dto/merchant";

export const NotAcceptingOrdersBannerContent = ({
  merchant,
}: {
  merchant: Merchant;
}) => {
  const pathName = usePathname();

  const getText = (merchant: any) => {
    const isShopPage: boolean = pathName.includes("shop");
    let text = "orders";

    if (
      (isShopPage && merchant.isService && merchant.isHybrid) ||
      merchant.isRestaurant ||
      merchant.isRetail
    ) {
      text = "orders";
    } else {
      text = "appointments";
    }

    return text;
  };

  const text = getText(merchant);

  return (
    <div
      data-testid="not-accepting-order-banner"
      className="w-screen h-[48px] flex flex-row justify-center items-center bg-[#E6F3FF] shadow-md"
    >
      {merchant.isEssentialMerchant && (
        <p className="text-center py-4">
          We don&#39;t accept online orders - please contact us directly for any
          purchases.
        </p>
      )}
      {!merchant.isEssentialMerchant && (
        <p className="text-center py-4">
          {merchant.name} isn&#39;t accepting online {text} right now.
        </p>
      )}
    </div>
  );
};
